import Sidebar from './sidebar';
import Panel from './panel';
import PanelLayers from './panel-layers';
import PanelLayerElement from './panel-layer-elements';
import PanelGuides from './panel-guides';

export { Sidebar, Panel, PanelLayers, PanelLayerElement, PanelGuides };

export default {
  Sidebar: Sidebar,
  Panel: Panel,
  PanelLayers: PanelLayers,
  PanelLayerElement: PanelLayerElement,
  PanelGuides: PanelGuides
};